import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../messages";
import toastr from "toastr";
import holidaysServices from "./holidaysServices";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getHolidays = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_HOLIDAYS,
      payload: true,
    });
    const resp = await holidaysServices.getHolidays(filters);
    const resp2 = await holidaysServices.getHolidays();
    let temp = { data: [] };
    resp2 &&
      resp2.data.data.map((item) => {
        if (!temp.data.find((t) => t.anio === item.anio)) {
          temp.data.push(item);
        }
      });

    dispatch({
      type: actions.GET_HOLIDAYS,
      payload: { holiday: filters.empresa !== "" ? resp.data: {data:[],count:0 } , holidayAnio: temp },
    });
    dispatch({
      type: actions.HOLIDAYS_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.HOLIDAYS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_HOLIDAYS,
      payload: false,
    });
  }
};

export const deleteHoliday = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_HOLIDAYS,
      payload: true,
    });
    await holidaysServices.deleteHoliday(id);
    const { data, count } = getState().holiday.holiday;
    const { data: dataAnio } = getState().holiday.holidayAnio
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_HOLIDAYS,
      payload: {holiday:{
          data: _data,
          count: count - 1,
        },
        holidayAnio: {data:dataAnio}
      },
    });
    dispatch({
      type: actions.HOLIDAYS_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.HOLIDAYS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_HOLIDAYS,
      payload: false,
    });
  }
};

export const editHoliday =
  (req, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_HOLIDAYS,
        payload: true,
      });
      const resp = await holidaysServices.editHoliday(req.id, req);
      const { data, count } = getState().holiday.holiday;
      const { data: dataAnio } = getState().holiday.holidayAnio
      let _data = data.slice();
      _data[index] = resp.data;
      dispatch({
        type: actions.GET_HOLIDAYS,
        payload: {holiday: {
            data: _data,
            count: count,
            }, holidayAnio: {data:dataAnio}
        },
      });
      dispatch({
        type: actions.FORM_HOLIDAYS_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.HOLIDAYS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_HOLIDAYS,
        payload: false,
      });
    }
  };

export const saveHoliday =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_HOLIDAYS,
        payload: true,
      });
      const resp = await holidaysServices.saveHoliday(req);
      const { data, count } = getState().holiday.holiday;
      const { data: dataAnio } = getState().holiday.holidayAnio;
      let _dataAnio = dataAnio;
      if (!_dataAnio.find((t) => t.anio === resp.data.anio)) {
        _dataAnio.push(resp.data);
      }
      dispatch({
        type: actions.GET_HOLIDAYS,
        payload: { holiday: {
            count: count + 1,
            data: [...data, resp.data],
        }, holidayAnio: {data:_dataAnio}
        },
      });
      dispatch({
        type: actions.FORM_HOLIDAYS_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_HOLIDAYS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_HOLIDAYS,
        payload: false,
      });
    }
  };
